import { ApplicationEmbedded } from "../application/types";
import { VersionedEntity } from "../core/Entity";
import { LayoutInsert, LayoutInsertType } from "../layout/types";
import { WizardMaskEmbedded } from "../wizard_mask/types";

export type WizardInstanceConfig = {
  layout?: {
    action: "create" | "edit";
    layoutSource: string;
    ref: string;
    flow: "admin" | "single-use";
    allowedInsertTypes?: LayoutInsertType[];
    predefinedInserts?: (Partial<Omit<LayoutInsert, "ref" | "type">> &
      Pick<LayoutInsert, "ref" | "type">)[];
    allowInsertDelete: boolean;
    allowInsertCreate: boolean;
  };
  template?: {
    action: "create" | "edit";
    ref: string;
  };
};

export enum WizardInstanceEntityState {
  CREATED = "created",
  PENDING = "pending",
  SUCCESS = "success",
  FAILED = "failed",
}

export type WizardInstanceGetResponse = VersionedEntity<{
  application: ApplicationEmbedded;
  wizardMask: WizardMaskEmbedded;
  config: WizardInstanceConfig;
  state: WizardInstanceEntityState;
  origins?: string[];
}>;

export type WizardInstanceEmbedded = Pick<WizardInstanceGetResponse, "id">;

export const RESOURCE_PATH = "/wizard_instances";
